import React, { useState, useEffect } from 'react'

//Componentes
import OvaCard from './OvaCard'
import styled from 'styled-components';

//Servicios
import ProgresoService from '../../../services/ProgresoService';

function OvaCards({ ovas }) {
    //Estados
    const [progreso, setProgreso] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //Map de tarjetas de OVA
    const OvaCards = ovas.map((ova) =>
        <OvaCard ova={ova} progreso={calcularPorcentaje(progreso[ova._id])} key={ova._id}></OvaCard>
    )

    //Cargar Datos a los estados
    useEffect(() => {
        setIsLoading(true);
        ProgresoService.obtenerProgreso().then(res => {
            setProgreso(res[0].grupos[0].progreso);
            setIsLoading(false);
        }).catch((e)=>isLoading(false));
    }, [])

    //Calcular el porcentaje de ova completado
    function calcularPorcentaje(progreso) {
        if(progreso!=undefined){
            let completado = 0;
            progreso.forEach(element => {
                if (typeof element === 'object') {
                    if (element?.success == true) {
                        completado++;
                    }
                } else {
                    if (element == true) {
                        completado++;
                    }
                }
            });
            return Math.round((completado / progreso.length) * 100);
        }
        
    }

    return (
        <Cards>
            {!isLoading &&
                OvaCards
            }
        </Cards>

    )
}

export default OvaCards

const Cards = styled.div`
   display: flex;   
   flex-direction:column;
   padding: 0 64px;
`;
